// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1-8A9","title":"ClientInsurance_title__gkfDY","itemText":"ClientInsurance_itemText__vHA8E"};